jQuery(document).ready(function(){
	jQuery('#newspopup .close').click(function(e){
		e.preventDefault();
		jQuery('#newspopup').hide();
	});
	jQuery('.newsletter_open').click(function(e){
		e.preventDefault();
		jQuery('#newspopup').show();
	});
});